import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import JsonCodeEditor from "../../../shared/components/json-code-editor";

type jsonT = {
	step: 3 | 2;
	data: {};
} | null;

interface propsI {
	json: jsonT;
	modalReturnOpened: boolean;
	setModalReturnOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ModalReturn({
	modalReturnOpened,
	setModalReturnOpened,
	json,
}: propsI) {
	return (
		<Modal
			open={modalReturnOpened}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "90%",
					bgcolor: "background.paper",
					boxShadow: 24,
					p: 4,
				}}
			>
				<div style={{ overflow: "scroll", maxHeight: "500px" }}>
					<Typography
						id="modal-modal-title"
						variant="h5"
						component="h2"
						textAlign="center"
					>
						Resultado da ultima requisição:
					</Typography>
					<JsonCodeEditor
						value={JSON.stringify(json?.data, null, 2)}
						readOnly
						minHeight="200px"
					/>
				</div>
				<Grid
					gap={3}
					container
					marginTop={3}
					alignItems="center"
					justifyContent="center"
				>
					<Button
						variant="outlined"
						size="large"
						color="info"
						onClick={() => setModalReturnOpened(false)}
					>
						Fechar
					</Button>
				</Grid>
			</Box>
		</Modal>
	);
}
